export default{
    apiUrl: 'https://www.financiaremprende.com/api/',
    // apiUrl: 'http://financiar.loc/api/'
}
